module.exports = __webpack_public_path__ + "static/media/icon-freska.b8d613e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-freska.svg
// module id = 211
// module chunks = 0